/**
 * defa.views.RoleApplicationContainerView
 * A Container for all the roleApplication related views.
 * @version 1.0.0
 */


import RoleApplicationCollectionView from 'scripts/defa/role-applications/view-role-application-collection-view';
import RoleApplicationView           from 'scripts/defa/role-applications/view-role-application-view';
import ActiveContainer               from '../../poppet/active-container';
import template                      from 'scripts/defa/role-applications/template-role-application-container.jst.html';


const channelNav = Bb.Radio.channel( 'nav' );
const channel = Bb.Radio.channel( 'object' );
const channelLayout = Bb.Radio.channel( 'layout' );


const selectors = {
	container          : '[data-region=container]',
	cancel             : '[data-click=applications-cancel]'
};

export const RoleApplicationContainerView = ActiveContainer.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	
	template,
	regions   : {
		container: selectors.container
	},
	
	ui : {
		cancel : selectors.cancel,
	},
	
	navHandler: 'internal',
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------

	
	/**
	 * Triggers when the child view triggers an "open" event.
	 * This happens when the user clicks on an application.
	 * @void
	 */
	onChildviewOpen( childView ) {
		channelNav.trigger( 'roleapplication:review', [childView.model.get('id'), ] );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attaches a designated view into the container region.
	 * @void
	 */
	attachView() {
		switch ( this.options.view ) {
			case 'role:applications':
				this._showAllRoleApplications();
				break;
			
			case 'role:application':
				this._showSingleRoleApplication();
				break;
		}
	},
	
	/**
	 * Displays a collectionView of all roleApplications.
	 * @void
	 */
	_showAllRoleApplications() {
		this.showElement('cancel');
		let roleApplicationCollectionView = new RoleApplicationCollectionView({
			collection: this.options.roleApplications,
		});
		this.showChildView( 'container', roleApplicationCollectionView );
	},
	
	/**
	 * Displays a approve/reject view for a specific roleApplication.
	 * @void
	 */
	_showSingleRoleApplication() {
		let roleApplicationView = new RoleApplicationView(_.extend(this.options,{
			model : this.options.roleApplication,
		}));
		this.showChildView( 'container', roleApplicationView );
	},
} );
export default RoleApplicationContainerView;
